import PubSub from "pubsub-js";

// Global, persistent period (date range) + comparison, shared by every
// analytics page and driven by the top-bar control. Persists across
// navigation via localStorage; broadcasts changes so mounted pages reload.
//
// Range vocabulary is the shared RANGES set (this_month / this_quarter /
// this_year / last_month / all_time, …). Comparison is the Activity-menu
// vocabulary ('prev_period' | 'prev_year'). Pages whose own option set is
// narrower should fall back to their default when the global range isn't in
// their list (handled at the page).

const RANGE_KEY = "plunk-global-range";
const COMP_KEY = "plunk-global-comp";
export const PERIOD_CHANGED = "plunk-period-changed";

// ONE canonical default so every page + the top-bar control agree on an
// unset (fresh session / new tenant) state. The `fallback` params below are
// intentionally IGNORED for the initial value: divergent per-page fallbacks
// (Territory this_quarter, Dashboard this_month, …) made pages disagree with
// the control until the user picked a range — the whole point of a single
// global control is one shared value. Pages whose own option set can't render
// the global range still narrow it locally (e.g. Product Performance's presetOr).
const DEFAULT_RANGE = "this_month";
const DEFAULT_COMP = "prev_period";
export function getGlobalRange() {
  try {
    return localStorage.getItem(RANGE_KEY) || DEFAULT_RANGE;
  } catch (e) {
    return DEFAULT_RANGE;
  }
}
export function getGlobalComp() {
  try {
    return localStorage.getItem(COMP_KEY) || DEFAULT_COMP;
  } catch (e) {
    return DEFAULT_COMP;
  }
}
export function setGlobalRange(range) {
  if (!range) return;
  try {
    localStorage.setItem(RANGE_KEY, range);
  } catch (e) {/* private mode */}
  PubSub.publish(PERIOD_CHANGED, {
    range,
    comp: getGlobalComp()
  });
}
export function setGlobalComp(comp) {
  if (!comp) return;
  try {
    localStorage.setItem(COMP_KEY, comp);
  } catch (e) {/* private mode */}
  PubSub.publish(PERIOD_CHANGED, {
    range: getGlobalRange(),
    comp
  });
}

// Subscribe to period changes; returns a token. `fn` receives { range, comp }.
export function subscribePeriod(fn) {
  return PubSub.subscribe(PERIOD_CHANGED, (msg, data) => fn(data || {}));
}
export function unsubscribePeriod(token) {
  if (token) PubSub.unsubscribe(token);
}